// Mirrored in applications/platform-app/components/web-analytics — change both.
import React from 'react';
import { RUBY, fmt } from '../format';

/** Two stacked series per bucket (bottom grey, top ruby). Ported from the mockup's stackChart(). */
export const StackBars: React.FC<{
  bottom: number[];
  top: number[];
  labels?: string[];
  height?: number;
  bottomName?: string;
  topName?: string;
  bottomColor?: string;
  topColor?: string;
}> = ({ bottom, top, labels = [], height = 200, bottomName = 'Allowed', topName = 'Blocked', bottomColor = '#e7e5e4', topColor = RUBY }) => {
  const W = 900, H = height, pad = 28, n = Math.max(bottom.length, top.length);
  const mx = Math.max(0, ...Array.from({ length: n }, (_, i) => (bottom[i] || 0) + (top[i] || 0))) * 1.1 || 1;
  const slot = (W - pad * 2) / Math.max(1, n);
  const bw = slot * 0.7;
  const x = (i: number) => pad + i * slot + (slot - bw) / 2;
  const sc = (v: number) => (v / mx) * (H - pad * 2);
  return (
    <svg viewBox={`0 0 ${W} ${H}`} width="100%" preserveAspectRatio="none" style={{ display: 'block', height: H }} role="img" aria-label="Bar chart">
      {Array.from({ length: n }, (_, i) => {
        const a = bottom[i] || 0, b = top[i] || 0;
        const h1 = sc(a), h2 = sc(b);
        const l = labels[i] ? `${labels[i]} · ` : '';
        return (
          <g key={i}>
            <rect x={x(i)} y={H - pad - h1} width={bw} height={h1} fill={bottomColor} rx={2}><title>{`${l}${bottomName} ${fmt(a)}`}</title></rect>
            <rect x={x(i)} y={H - pad - h1 - h2} width={bw} height={h2} fill={topColor} rx={2}><title>{`${l}${topName} ${fmt(b)}`}</title></rect>
          </g>
        );
      })}
    </svg>
  );
};
